module.exports = __webpack_public_path__ + "images/emoji/bikini.6fea79e487e5409c1429.png";